// 15 demo flashcards — Science & Math
// Export to database later; IDs are stable slugs for that migration.

const FLASHCARDS = [
  // ── Science ─────────────────────────────────────────────────────────────
  {
    id: 'osmosis',
    subject: 'Science',
    term: 'Osmosis',
    definition:
      'The movement of water molecules through a semi-permeable membrane from an area of low solute concentration to high solute concentration.',
    funFact: 'Osmosis is why your fingers wrinkle in the bath — water moves out of your skin cells into the salty bathwater.',
  },
  {
    id: 'mitosis',
    subject: 'Science',
    term: 'Mitosis',
    definition:
      'A type of cell division that produces two genetically identical daughter cells, each with the same number of chromosomes as the parent cell.',
    funFact: 'Your body performs about 25 million cell divisions every second through mitosis.',
  },
  {
    id: 'newtons-third-law',
    subject: 'Science',
    term: "Newton's Third Law",
    definition:
      'For every action there is an equal and opposite reaction. Forces always come in pairs acting on two different objects.',
    funFact: 'Rockets work entirely because of this law — hot gas shoots down, and the rocket shoots up.',
  },
  {
    id: 'entropy',
    subject: 'Science',
    term: 'Entropy',
    definition:
      'A measure of disorder or randomness in a system. The Second Law of Thermodynamics states that entropy of an isolated system always increases over time.',
    funFact: 'The universe is constantly moving toward higher entropy — which is why ice melts but puddles never refreeze on their own.',
  },
  {
    id: 'photosynthesis',
    subject: 'Science',
    term: 'Photosynthesis',
    definition:
      'The process by which plants, algae, and some bacteria use sunlight, water, and CO₂ to produce glucose and oxygen.',
    funFact: 'A single large tree can absorb up to 48 pounds of CO₂ per year through photosynthesis.',
  },
  {
    id: 'tectonic-plates',
    subject: 'Science',
    term: 'Tectonic Plates',
    definition:
      'Massive, irregularly shaped slabs of solid rock that make up Earth\'s outer layer. Their slow movement causes earthquakes, volcanoes, and mountain formation.',
    funFact: 'Plates move at roughly the same speed your fingernails grow — about 2–10 cm per year.',
  },
  {
    id: 'black-hole',
    subject: 'Science',
    term: 'Black Hole',
    definition:
      'A region of space where gravity is so intense that nothing — not even light — can escape once it crosses the event horizon.',
    funFact: 'The first image of a black hole was captured in 2019; it is 6.5 billion times more massive than our Sun.',
  },
  {
    id: 'dna',
    subject: 'Science',
    term: 'DNA',
    definition:
      'Deoxyribonucleic acid — the double-helix molecule that carries the genetic instructions for the development, functioning, and reproduction of all living organisms.',
    funFact: 'If you stretched out all the DNA in one human cell, it would be about 2 meters long, yet it fits inside a nucleus 6 micrometers wide.',
  },
  // ── Math ─────────────────────────────────────────────────────────────────
  {
    id: 'prime-number',
    subject: 'Math',
    term: 'Prime Number',
    definition:
      'A natural number greater than 1 that has no positive divisors other than 1 and itself. Examples: 2, 3, 5, 7, 11, 13.',
    funFact: '2 is the only even prime number. All other even numbers are divisible by 2, so they can\'t be prime.',
  },
  {
    id: 'pythagorean-theorem',
    subject: 'Math',
    term: 'Pythagorean Theorem',
    definition:
      'In a right triangle, the square of the hypotenuse equals the sum of the squares of the other two sides: a² + b² = c².',
    funFact: 'Ancient Egyptians used a knotted rope with a 3-4-5 ratio to create perfect right angles when building the pyramids.',
  },
  {
    id: 'pi',
    subject: 'Math',
    term: 'Pi (π)',
    definition:
      'The ratio of a circle\'s circumference to its diameter, approximately 3.14159. It is irrational — its decimal expansion never repeats or terminates.',
    funFact: 'Pi has been calculated to over 100 trillion digits, yet just 39 decimal places are enough to calculate the circumference of the observable universe to within a hydrogen atom\'s width.',
  },
  {
    id: 'fibonacci-sequence',
    subject: 'Math',
    term: 'Fibonacci Sequence',
    definition:
      'A sequence where each number is the sum of the two preceding ones: 0, 1, 1, 2, 3, 5, 8, 13, 21 … Formally, F(n) = F(n-1) + F(n-2).',
    funFact: 'Sunflower seeds, pine cones, and spiral galaxies all follow Fibonacci patterns — nature\'s favorite growth formula.',
  },
  {
    id: 'exponent',
    subject: 'Math',
    term: 'Exponent',
    definition:
      'A number that indicates how many times the base is multiplied by itself. In 2⁵ = 32, the base is 2 and the exponent is 5.',
    funFact: 'Exponential growth is why a single bacterium can become over 1 billion bacteria in just 10 hours under ideal conditions.',
  },
  {
    id: 'mean',
    subject: 'Math',
    term: 'Mean (Average)',
    definition:
      'The sum of all values in a dataset divided by the number of values. It is the most common measure of central tendency.',
    funFact: 'The mean can be misleading — Bill Gates walking into a café raises the mean income of everyone inside dramatically, but the median barely changes.',
  },
  {
    id: 'irrational-number',
    subject: 'Math',
    term: 'Irrational Number',
    definition:
      'A real number that cannot be expressed as a simple fraction p/q where p and q are integers. Its decimal expansion is infinite and non-repeating.',
    funFact: 'The ancient Greeks were so disturbed when they discovered √2 was irrational that, legend says, they drowned the mathematician who proved it.',
  },
];

export default FLASHCARDS;
